import { render, staticRenderFns } from "./PrimaryContactInfo.vue?vue&type=template&id=450808c2&scoped=true"
import script from "./PrimaryContactInfo.vue?vue&type=script&lang=js"
export * from "./PrimaryContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450808c2",
  null
  
)

export default component.exports